import type { ReactElement } from 'react';
import type { FieldError } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export type FieldErrorProps = {
    error?: FieldError;
};

export function FieldError({ error }: FieldErrorProps): ReactElement {
    const { t } = useTranslation('sales-draft');

    const errorMessage = error ? t('form_error_required') : undefined;

    if (errorMessage) {
        return <div className="text-sm text-red-600">{errorMessage}</div>;
    }
    return <></>;
}
